import ItemSlotManager from "./ItemSlotManager";

export default ItemSlotManager;
export { ItemSlotManager };
